import React from "react";
import type { TextStyle } from "react-native";

import Pressable from "$src/core/components/atoms/Pressable/Pressable";
import Text from "$src/core/components/atoms/Text/Text";
import useTranslation from "$src/core/hooks/use-translation";

import $ from "./TruncatedText.styles";

type Props = {
  text: string | undefined;
  maxChars?: number;
  style?: Omit<TextStyle, "cursor">;
  onShowMore?: () => void;
};

const TruncatedText: React.FC<Props> = ({
  text,
  maxChars = 300,
  style,
  onShowMore,
}) => {
  const { t } = useTranslation();

  const hasReadMore = text && text.length > maxChars;

  if (!hasReadMore) {
    return (
      <Text accessibilityRole="text" preset="body" style={style}>
        {text}
      </Text>
    );
  }

  if (!onShowMore) {
    return (
      <Text accessibilityRole="text" preset="body" numberOfLines={maxChars}>
        {text.slice(0, maxChars)}
        <Text preset="heading7" accessibilityRole="text" style={$.readMoreText}>
          {"...  "}
        </Text>
      </Text>
    );
  }

  return (
    <Pressable onPress={onShowMore} accessibilityRole="button" style={style}>
      <Text accessibilityRole="text" preset="body" numberOfLines={maxChars}>
        {text.slice(0, maxChars)}
        <Text preset="heading7" accessibilityRole="text" style={$.readMoreText}>
          {"...  "}
          {t("COMMON/READ_MORE")}
        </Text>
      </Text>
    </Pressable>
  );
};

export default TruncatedText;
